import { FormControl, Input } from '@visualfabriq/vf-ui-kit';

import * as DataStagingStep from 'src/dto/PipelineStep/DataStagingStep';

type ReplaceValueMethodProps = {
  fields: DataStagingStep.ReplaceValue;
  onUpdate: (fields: DataStagingStep.ReplaceValue) => void;
};

export function ReplaceValueMethod(props: ReplaceValueMethodProps) {
  const { fields, onUpdate } = props;

  return (
    <>
      <FormControl label="Replace From" disabled={false} required>
        <Input
          value={fields.from_replace as unknown as string}
          onChange={(event) =>
            onUpdate({
              ...fields,
              from_replace: event.target.value,
            })
          }
        />
      </FormControl>

      <FormControl label="Replace To" disabled={false} required>
        <Input
          value={fields.to_replace as unknown as string}
          onChange={(event) =>
            onUpdate({
              ...fields,
              to_replace: event.target.value,
            })
          }
        />
      </FormControl>
    </>
  );
}
